import { ObjectTyped } from '@price-for-profit/micro-services';
import { SelectInput } from 'shared/components';
import { useUserMappings, useUsers } from 'shared/queries';

export function UserDropdown() {
  const users = useFilteredUsers();
  return (
    <SelectInput
      name='user'
      label='Application Users'
      options={users || []}
      loading={!Boolean(users)}
      getOptionLabel={option => option.displayName}
      getOptionSelected={(option, value) => option.id === value.id}
      rules={{ required: { message: 'User is required', value: true } }}
    />
  );
}

function useFilteredUsers() {
  const { userMappings } = useUserMappings();
  const { users } = useUsers();

  if (!userMappings || !users) {
    return null;
  }
  const map = ObjectTyped.fromEntries(userMappings.map(mapping => [mapping.id, true]));

  const filteredUsers = users.filter(user => !map[user.id]);

  return filteredUsers;
}
